export default {
  // AI 组件（ai集成）
  'ai.integration.ref': '参考',
  'ai.integration.firstLastFrame': '首尾帧',
  'ai.integration.firstFrame': '首帧',
  'ai.integration.lastFrame': '尾帧',
  'ai.integration.promptPlaceholder':
    '描述视频画面内容和动态过程，使用 @ 指定参考图或参考视频',
  'ai.integration.panelSpec': '参数',
  'ai.integration.generate.count': '生成{count}条',
  'ai.integration.generate.option': '{count}条',
  'ai.integration.generate.costTooltip': '消耗 {points} 积分',
  'ai.integration.modelPlaceholder': '选择模型',
  'ai.integration.submitSuccess': '已提交生成任务',
  'ai.integration.submitFailed': '提交失败，请重试',
  'ai.integration.submitNoWorkspace': '未找到工作空间，请先登录',
  'ai.integration.submitNoModel': '请先选择模型',
  'ai.integration.submitting': '提交中...',
};

